import(/* webpackMode: "eager" */ "/codebuild/output/src396947351/src/Website-V1/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src396947351/src/Website-V1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["AgentMotion"] */ "/codebuild/output/src396947351/src/Website-V1/src/components/site/AgentMotion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AiCaptureShowcase"] */ "/codebuild/output/src396947351/src/Website-V1/src/components/site/AiCaptureShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AiFormBuilderShowcase"] */ "/codebuild/output/src396947351/src/Website-V1/src/components/site/AiFormBuilderShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AmendmentFlow"] */ "/codebuild/output/src396947351/src/Website-V1/src/components/site/AmendmentFlow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuditTrailShowcase"] */ "/codebuild/output/src396947351/src/Website-V1/src/components/site/AuditTrailShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContactBand"] */ "/codebuild/output/src396947351/src/Website-V1/src/components/site/ContactBand.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DragDropShowcase"] */ "/codebuild/output/src396947351/src/Website-V1/src/components/site/DragDropShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FaqChat"] */ "/codebuild/output/src396947351/src/Website-V1/src/components/site/FaqChat.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SdtmExportShowcase"] */ "/codebuild/output/src396947351/src/Website-V1/src/components/site/SdtmExportShowcase.tsx");
